module.exports = __webpack_public_path__ + "static/perspectiveDesktop@2x-a08da9a48246398e7b74fdc296bc89ad.png";